import { Modal } from "antd";
/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import {
  useIsMobile,
  useIsTab,
  useIsMidTabWindow,
  useIsmidSizedMonitor,
} from "../../hooks/useIsMobile";
import {
  buttonActions,
  inlineSignInModalStyle,
  inlineModalWidthStyle,
} from "../../constants/commons";
import { SignUp } from "../../components/SignUp";
import { signupInModalStyle } from "./styles";
import { triggerUserLogin } from "../../utils/helpers";
interface ISignUpModalProps {
  visible?: boolean;
  handleCancel?: () => void;
  handleOk?: (e: any) => void;
  modalType?: string | undefined;
}
export const SignUpModal: React.FC<ISignUpModalProps> = (
  props: ISignUpModalProps
) => {
  const [currentModalType, setCurrentModalType] = React.useState<string>();
  const { visible, handleCancel, modalType } = props;
  const isMobileView = useIsMobile();
  const isTabView = useIsTab();
  const isMidTabWindowView = useIsMidTabWindow();
  const isMidSizedMonitor = useIsmidSizedMonitor();

  React.useEffect(() => {
    modalType && setCurrentModalType(modalType);
  }, [modalType]);

  // Function used for switching the rendering of modal from SIGNUP to SIGNIN
  const onLoginClick = () => {
    triggerUserLogin();
  };

  const renderChildren = (modalType: string) => {
    switch (modalType) {
      case buttonActions.SIGNUP:
        return <SignUp onLoginClick={onLoginClick} onClose={handleCancel} />;

      default:
        break;
    }
  };

  const getStyleBasedonWindowview = () => {
    if (isMobileView) {
      return currentModalType === buttonActions.SIGNUP
        ? inlineSignInModalStyle.mobileViewStyleSignupModal
        : inlineSignInModalStyle.mobileViewStyle;
    }
    if (isTabView) {
      return inlineSignInModalStyle.tabViewStyle;
    }
    if (isMidTabWindowView) {
      return inlineSignInModalStyle.midTabWindowStyle;
    }
    if (isMidSizedMonitor) {
      return inlineSignInModalStyle.midSizedMonitorStyle;
    }
  };

  const getModalStyleWidth = () => {
    if (isMobileView) {
      if (currentModalType === buttonActions.SIGNUP) {
        return inlineModalWidthStyle.mobileViewStyle;
      }
      return inlineModalWidthStyle.deafultSignInModalWidth;
    }

    if (isTabView) {
      if (currentModalType === buttonActions.SIGNUP) {
        return inlineModalWidthStyle.tabViewStyle;
      }
      return inlineModalWidthStyle.deafultSignInModalWidth;
    }
    if (isMidTabWindowView) {
      if (currentModalType === buttonActions.SIGNUP) {
        return inlineModalWidthStyle.midTabWindowStyle;
      }
      return inlineModalWidthStyle.deafultSignInModalWidth;
    }
    if (isMidSizedMonitor) {
      if (currentModalType === buttonActions.SIGNUP) {
        return inlineModalWidthStyle.midSizedMonitorStyle;
      }
      return inlineModalWidthStyle.deafultSignInModalWidth;
    }
    if (currentModalType === buttonActions.SIGNUP) {
      return inlineModalWidthStyle.defaultSignUpModalWidth;
    }
    return inlineModalWidthStyle.deafultSignInModalWidth;
  };

  return (
    <span css={signupInModalStyle}>
      <Modal
        style={getStyleBasedonWindowview()}
        width={getModalStyleWidth()}
        visible={visible}
        onOk={handleCancel}
        destroyOnClose={true}
        centered
        footer={null}
        bodyStyle={{ padding: inlineModalWidthStyle.noPadding }}
        onCancel={handleCancel}
      >
        {currentModalType && renderChildren(currentModalType)}
      </Modal>
    </span>
  );
};
